import React, { Component } from "react";
import { connect } from "react-redux";
import { humanFileSize, numberWithCommas } from "../../utilities/utilities";
import { Loader } from "@mantine/core";
import { shouldShowDeveloperMessages } from "../../reducers/developerOverridesReducer";
import { showAsDeveloperMessage } from "../Developer/showAsDeveloperMessage";
import PreBox from "../PreBox";

class PermanentDeleteJobDetailsUnconnected extends Component {
	constructor(props) {
		super(props);
		this.state = {
			confirmTextBox: "",
		};
	}

	getBasicJobDetailsForRegularUser() {
		// I want to show the basic information of what was deleted. This will only show the deletes made in the database
		// {"itemsProcessed":2220,"permanentDeleteGenerationJobID":444,"totalObjectsInManifest":2220,"deletedObjectCounts":{"databaseDeletes":{"documentRecordsDeleted":1561,"documentVersionsRecordsDeleted":4898,"folderRecordsDeleted":651,"matterRecordsDeleted":1,"outgoingShareRecordsDeleted":1,"appliedDocumentTagsRecordsDeleted":1454,"emailRecordsDeleted":4,"matterNoteRecordsDeleted":3},"searchIndexDeletes":{"documentAndDocumentVersions":6457,"emailsDeletedFromSearch":4,"totalItemsDeletedFromSearch":3},"addedToConfirmedManifest":{"documentsAddedToConfirmedManifest":4908,"emailsAddedToConfirmedManifest":7}}}
		const { executePermanentDeleteJob, documentVersionDeletedData } =
			this.props;

		if (executePermanentDeleteJob?.jobDataError) {
			return (
				<div style={{ color: "red" }}>
					{executePermanentDeleteJob.jobDataError}
				</div>
			);
		}

		const jobData = executePermanentDeleteJob?.jobData || {};
		const deletedObjectCounts = jobData?.deletedObjectCounts || {};

		const databaseDeletes = deletedObjectCounts?.databaseDeletes || {};
		// these are items that were either no longer in the trash or the user did not have permissions to delete, so they were not deleted and are tracked in this deniedItems object
		const deniedItems = deletedObjectCounts?.deniedItems || {};

		if (databaseDeletes.matterRecordsDeleted) {
			// we need to update folder counts
			databaseDeletes.folderRecordsDeleted -=
				databaseDeletes.matterRecordsDeleted * 3; // docs, email, notes root folders
			if (databaseDeletes.folderRecordsDeleted <= 0) {
				delete databaseDeletes.folderRecordsDeleted;
			}
			databaseDeletes.numberOfRootFoldersDeleted =
				databaseDeletes.matterRecordsDeleted * 3; // docs, email, notes root folders
		}

		let deniedItemsTemp = {};

		if (deniedItems.matters) {
			// "deniedItems": {
			// 	"documents": [
			// 		52,
			// 		53,
			// 		51
			// 	],
			// 	"emails": [
			// 		10,
			// 		11
			// 	],
			// 	"notes": [
			// 		9,
			// 		8
			// 	],
			// 	"folders": [
			// 		112,
			// 		113,
			// 		114,
			// 		115,
			// 		116,
			// 		117
			// 	],
			// 	"matters": [
			// 		28
			// 	]
			// }
			let numMattersDenied = deniedItems.matters?.length;
			if (numMattersDenied > 0) {
				// we need to update folder counts
				const numRootMatterFoldersDenied = numMattersDenied * 3;
				deniedItemsTemp.matter = numMattersDenied;

				deniedItemsTemp.folder =
					(deniedItems.folders?.length || 0) -
					numRootMatterFoldersDenied;
			}
		} else {
			deniedItemsTemp.matter = 0;
			deniedItemsTemp.folder = deniedItems.folders?.length || 0;
		}

		deniedItemsTemp.document = deniedItems.documents?.length || 0;
		deniedItemsTemp.email = deniedItems.emails?.length || 0;
		deniedItemsTemp.note = deniedItems.notes?.length || 0;

		let deniedItemsMessageArray = [];

		Object.entries(deniedItemsTemp).forEach(([key, value]) => {
			if (value > 0) {
				deniedItemsMessageArray.push(
					`${numberWithCommas(value)} ${key.charAt(0).toUpperCase() + key.slice(1)}${value > 1 ? "s" : ""}`
				);
			}
		});

		return (
			<div>
				<h4>Operation Details</h4>
				<div>
					The following Objects were permanently deleted as part of
					this operation
				</div>
				<ul
					style={{
						paddingLeft: 15,
						paddingTop: 10,
					}}
				>
					{databaseDeletes.estimatedSizeInBytesInS3 ? (
						<li>
							{`Approximately ${humanFileSize(
								databaseDeletes.estimatedSizeInBytesInS3,
								true
							)} of Documents and Emails to be deleted`}
						</li>
					) : null}
					{databaseDeletes.clientRecordsDeleted ? (
						<li>
							{`${numberWithCommas(
								databaseDeletes.clientRecordsDeleted
							)} Client${databaseDeletes.clientRecordsDeleted > 1 ? "s" : ""}`}
						</li>
					) : null}
					{databaseDeletes.matterRecordsDeleted ? (
						<li>
							{`${numberWithCommas(
								databaseDeletes.matterRecordsDeleted
							)} Matter${databaseDeletes.matterRecordsDeleted > 1 ? "s" : ""}`}
						</li>
					) : null}
					{databaseDeletes.folderRecordsDeleted ? (
						<li>
							{`${numberWithCommas(
								databaseDeletes.folderRecordsDeleted
							)} Folder${databaseDeletes.folderRecordsDeleted > 1 ? "s" : ""}`}
						</li>
					) : null}
					{databaseDeletes.documentRecordsDeleted ? (
						<li>
							{`${numberWithCommas(
								databaseDeletes.documentRecordsDeleted
							)} Document${databaseDeletes.documentRecordsDeleted > 1 ? "s" : ""}`}
						</li>
					) : null}
					{databaseDeletes.emailRecordsDeleted ? (
						<li>
							{`${numberWithCommas(
								databaseDeletes.emailRecordsDeleted
							)} Email${databaseDeletes.emailRecordsDeleted > 1 ? "s" : ""}`}
						</li>
					) : null}
					{databaseDeletes.matterNoteRecordsDeleted ? (
						<li>
							{`${numberWithCommas(
								databaseDeletes.matterNoteRecordsDeleted
							)} Matter Note${databaseDeletes.matterNoteRecordsDeleted > 1 ? "s" : ""}`}
						</li>
					) : null}
				</ul>
				{Array.isArray(documentVersionDeletedData?.textLines) ? (
					<ul>
						{documentVersionDeletedData.textLines.map(
							(dvdd, index) => (
								<li key={index}>{dvdd}</li>
							)
						)}
					</ul>
				) : null}
				{deniedItemsMessageArray.length > 0 ? (
					<div style={{ marginTop: 10, color: "red" }}>
						Note the following items were not deleted because they
						were either no longer in the trash or you did not have
						permissions to delete them:{" "}
						<ul>
							{deniedItemsMessageArray.map((message, index) => (
								<li key={index}>{message}</li>
							))}
						</ul>
					</div>
				) : null}
			</div>
		);
	}

	getAllJobDetails() {
		// this will show all the details of the job, including the developer messages

		return (
			<div>
				<div>
					<strong>Execute Permanent Delete Job Data:</strong>
					<PreBox
						style={{
							maxWidth: "500px",
							whiteSpace: "pre",
							overflow: "auto",
						}}
					>
						{JSON.stringify(
							this.props.executePermanentDeleteJob?.jobData,
							null,
							2
						)}
					</PreBox>
				</div>
				<div>
					<strong>
						Generate Permanent Delete Manifest Job Data:
					</strong>
					<PreBox
						style={{
							maxWidth: "500px",
							whiteSpace: "pre",
							overflow: "auto",
						}}
					>
						{JSON.stringify(
							this.props.permanentDeleteManifestGenerationJob
								?.jobData,
							null,
							2
						)}
					</PreBox>
				</div>
				<div>
					<strong>Delete Document Version Info:</strong>
					<PreBox
						style={{
							maxWidth: "500px",
							whiteSpace: "pre",
							overflow: "auto",
						}}
					>
						{JSON.stringify(
							this.props.documentVersionDeletedData,
							null,
							2
						)}
					</PreBox>
				</div>
			</div>
		);
	}

	render() {
		// this loading prop is in the permanentDeleteJobDetailsObject that is passed into openGlobalDialog
		if (this.props.loading) {
			return <Loader />;
		}
		if (this.props.error) {
			return (
				<div style={{ color: "red" }}>
					Failed to load job details: {this.props.error}
				</div>
			);
		}
		const { executePermanentDeleteJob } = this.props;

		return (
			<div>
				<div style={{ marginBottom: 10 }}>
					<div>
						<div className="permanentDeleteJobInfo">
							<strong>Status</strong>
							<span>
								{executePermanentDeleteJob?.status === 1
									? executePermanentDeleteJob?.percentDone
										? `${executePermanentDeleteJob?.percentDone}% Complete`
										: "In Progress"
									: executePermanentDeleteJob?.status === 2
										? "Completed"
										: executePermanentDeleteJob?.status ===
											  3
											? "Failed"
											: "Unknown"}
							</span>
						</div>
						<div className="permanentDeleteJobInfo">
							<strong>Performed By</strong>
							<span>
								{
									executePermanentDeleteJob?.userPerformingOperationDisplayName
								}
							</span>
						</div>
						<div className="permanentDeleteJobInfo">
							<strong>Started</strong>
							<span>
								{new Date(
									executePermanentDeleteJob?.startTime
								).toLocaleString()}
							</span>
						</div>
						<div className="permanentDeleteJobInfo">
							<strong>Completed</strong>
							<span>
								{executePermanentDeleteJob?.endTime
									? new Date(
											executePermanentDeleteJob?.endTime
										).toLocaleString()
									: "Not yet completed"}
							</span>
						</div>
					</div>
					<div
						style={{ width: "100%", border: "1px solid black" }}
					></div>
					{this.getBasicJobDetailsForRegularUser()}
					{this.props.showDeveloperMessages
						? showAsDeveloperMessage(this.getAllJobDetails())
						: null}
				</div>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	let showDeveloperMessages = shouldShowDeveloperMessages(
		state.developerOverrides.showDeveloperMessages
	);

	return {
		showDeveloperMessages,
	};
};

const PermanentDeleteJobDetails = connect(mapStateToProps)(
	PermanentDeleteJobDetailsUnconnected
);

export default PermanentDeleteJobDetails;
